import { round } from 'lodash';
import { isNullish } from '@/utils/predicates';

const displayMultiplier = (isPercentage: boolean): number => (isPercentage ? 100 : 1);

export const convertToDisplayValue = (value: number | undefined, precision: number, isPercentage?: boolean) =>
  !isNullish(value) ? round(value * (isPercentage ? 100 : 1), precision) : value;

export const convertToSavedValue = (value: number | undefined, isPercentage?: boolean) =>
  !isNullish(value) && isPercentage ? value / 100 : value;

/** Convert raw value to display value */
export const toDisplayValue = (rawValue: number, isPercentage: boolean): number =>
  rawValue * displayMultiplier(isPercentage);

/** Convert display value back to raw value */
export const toRawValue = (displayValue: number, isPercentage: boolean): number =>
  displayValue / displayMultiplier(isPercentage);
